import { render } from "./PrintApplicationView.vue?vue&type=template&id=981f6ae6&ts=true"
import script from "./PrintApplicationView.vue?vue&type=script&lang=ts"
export * from "./PrintApplicationView.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/descript/vue-js-teq-application/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__